import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 1.5c0-.83.67-1.51 1.5-1.4a12 12 0 0 1 7.98 19.26c-.51.66-1.47.65-2.06.06-.58-.58-.57-1.53-.09-2.2a9 9 0 0 0-5.84-14.1C12.68 3 12 2.32 12 1.5Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }